class HeaderTransparent {
  constructor(fadeSections, header, stickyNav) {
    this.sections = fadeSections;
    this.sectionsValue = [];
    fadeSections.forEach((entry, index) => {
      this.sectionsValue[index] = 0;
    });
    this.header = header;
    this.stickyNav = stickyNav;
  }

  isTransparent() {
    let sum = 0;
    this.sectionsValue.forEach((item) => {
      sum += item;
    });
    return sum;
  }

  update(index, value = 1) {
    this.sectionsValue[index] = value;

    if (this.isTransparent() > 0) {
      this.header.style.backgroundColor = 'transparent';
      this.stickyNav.style.backgroundColor = 'transparent';
    } else {
      this.header.style.backgroundColor = null;
      this.stickyNav.style.backgroundColor = null;
    }
  }
}

const init = () => {
  const fadeSections = document.querySelectorAll('.js-section-fade');
  const header = document.querySelector('.js-header');
  const stickyNav = document.querySelector('.js-sticky-nav');
  const headerTransparent = new HeaderTransparent(fadeSections, header, stickyNav);
  fadeSections.forEach((section, index) => {
    section.classList.add('transition-opacity');
    section.style.opacity = 1;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        // Color fixed header & nav
        const isLargeViewport = window.innerWidth >= 1;

        if (isLargeViewport) {
          const isIntersectingWithHeader = entry.boundingClientRect.top
            - header.clientHeight < 150 && entry.boundingClientRect.bottom > 100;

          if (isIntersectingWithHeader) {
            headerTransparent.update(index, 1);
          } else {
            headerTransparent.update(index, 0);
          }

          if (section.classList.contains('gradient-both') || section.classList.contains('gradient-both-overlaps')) {
            section.style.opacity = entry.intersectionRatio * (section.clientHeight / 440);
          }

          if (section.classList.contains('gradient-top') && entry.boundingClientRect.top - header.clientHeight > 50) {
            section.style.opacity = entry.intersectionRatio * (section.clientHeight / 440);
          }

          if (section.classList.contains('gradient-bottom') && entry.boundingClientRect.top - header.clientHeight < 50) {
            section.style.opacity = entry.intersectionRatio * (section.clientHeight / 440);
          }

          if (section.classList.contains('gradient-top-overlaps') && entry.boundingClientRect.top - header.clientHeight > 50) {
            section.style.opacity = entry.intersectionRatio * (section.clientHeight / 440);
          }

          if (section.classList.contains('gradient-bottom-overlaps') && entry.boundingClientRect.top - header.clientHeight < 50) {
            section.style.opacity = entry.intersectionRatio * (section.clientHeight / 440);
          }
        }
      });
    }, {
      root: null,
      rootMargin: '0px',
      threshold: buildThresholdList(1000),
    });
    observer.observe(section);
  });

  function buildThresholdList(steps) {
    const thresholds = [];

    for (let i = 1; i <= steps; i += 1) {
      thresholds.push(i / steps);
    }

    return thresholds;
  }
};

export default {
  init,
};
